// extracted by mini-css-extract-plugin
export default {"apple-pay-button-white":"src_apple-pay-button-white__g5DJr","apple-pay-button":"src_apple-pay-button__PglCV","credit-card":"src_credit-card__NJ7VM"};